// Runtime helpers for snapshot DOM manipulation
window.__snapshotReady = true
